export function isDefinedAndNotEmpty(value) {
  if (value === null || value === undefined) {
    return false;
  }
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  if (typeof value === 'object') {
    return Object.keys(value).length > 0;
  }
  return String(value).trim().length > 0;
}

export default isDefinedAndNotEmpty; 